"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _courseDeclare = require("@/api/courseDeclare/courseDeclare");
var _validate = require("@/libs/validate1.js");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default
  },
  data: function data() {
    return {
      tabBars: ["概要信息", "课程负责人情况", "课程团队", "课程情况", "课程评价", "建设措施", "附件材料"],
      curIndex: 0,
      id: null,
      dialog: false,
      acceptVideo: ".mp4",
      acceptPdf: ".pdf",
      form0: {
        courseName: "",
        curriculumLevel: "",
        courseType: "",
        declarationDate: "",
        declarationUnit: "",
        name: "",
        professionalCode: "",
        projectCategory: "",
        majorCatId: "",
        majorGroupId: ""
      },
      rules0: {
        // declarationUnit:[{  required: true, message: "此项不能为空", trigger: "blur" }],
      },
      form1: {
        academicDegree: "",
        academicResearch: "",
        address: "",
        administrativePosition: "",
        birthday: "",
        courseLeaderTeachingList: [{
          classHour: "",
          courseName: "",
          courseType: "",
          sessionNumber: "",
          studentNumber: null
        }],
        department: "",
        education: "",
        email: "",
        mobile: "",
        name: "",
        sex: "",
        teachingResearch: "",
        teachingSituation: "",
        technicalPosition: ""
      },
      rules1: {
        // name: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        // sex:[{ required: true, message: "请选择性别", trigger: "blur" }],
        mobile: [
        // { required: true, message: "请输入手机号", trigger: "blur" },
        {
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }],
        email: [
        // { required: true, message: "请输入邮箱", trigger: "blur" },
        {
          validator: _validate.validateEMail,
          trigger: "blur"
        }]
      },
      form2: {
        courseLeaderId: "",
        teamListParams: [{
          birthday: "",
          jobContent: "",
          major: "",
          name: "",
          remarks: "",
          sex: "",
          technicalPosition: ""
        }],
        teamStructure: ""
      },
      rules2: {},
      form3: {
        constructionFoundation: "",
        courseContent: "",
        courseEachLectureListParams: [{
          duration: "",
          lecturer: "",
          title: ""
        }],
        courseLeaderId: "",
        courseName: "",
        positioningTarget: "",
        resourceReserve: "",
        totalHour: "",
        totalTime: ""
      },
      rules3: {},
      form4: {
        courseLeaderId: "",
        selfEvaluation: "",
        socialEvaluation: "",
        studentEvaluation: ""
      },
      rules4: {},
      form5: {
        constructionMeasures: "",
        courseLeaderId: ""
      },
      rules5: {},
      form6: {
        courseLeaderId: "",
        lectureVideo: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        otherFile1: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        otherFile2: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        }
      },
      rules6: {},
      majorList: [],
      majorListTwo: [],
      isGetMajor: 0
    };
  },
  methods: {
    // validatorMobile() {
    //   var re = /^1\d{10}$/;
    //        let str = this.form1.mobile;
    //        if(re.test(str)){
    //            alert('成功')
    //        }else {
    //            alert('抱歉手机号不合法')
    //       }
    // },
    closeVideo: function closeVideo() {
      this.dialog = false;
      console.log(this.$refs.skVideo2, 666);
      this.$refs.skVideo2.pause();
    },
    isnumber: function isnumber(val) {
      val = val.replace(/[^0-9]/gi, "");
      // 此处还可以限制位数以及大小
      return val;
    },
    open: function open() {
      this.dialog = true;
    },
    changeTab: function changeTab(i, index) {
      this.curIndex = index;
      this.getDetailThird();
    },
    /////////////////////////////////////////////////////////////
    chooseMajorTwo: function chooseMajorTwo(e) {
      for (var i in this.majorListTwo) {
        if (this.majorListTwo[i].id == e) {
          this.form0.professionalCode = this.majorListTwo[i].majorCode;
        }
      }
    },
    chooseMajor: function chooseMajor(e) {
      var _this = this;
      // console.log("ppp", this.$route.query.schoolType);
      this.form0.majorGroupId = '';
      this.form0.professionalCode = '';
      (0, _courseDeclare.getMatchMajorListAll)({
        businessId: "",
        parentId: e
        // type: this.$route.query.schoolType
      }).then(function (res) {
        if (res.code === 2000) {
          _this.majorListTwo = res.data;
        }
      });
      // for(let i in this.majorList){
      //   if(this.majorList[i].id == e){
      //     this.form0.professionalCode = this.majorList[i].majorCode
      //   }
      // }
    },
    getMajor: function getMajor() {
      var _this2 = this;
      (0, _courseDeclare.getMatchMajorListAll)({
        businessId: "",
        parentId: "",
        type: this.$route.query.schoolType
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.majorList = res.data;
        }
      });
    },
    // 附件三 立项建设申报书 根据id获取申报详情
    getDetailThird: function getDetailThird() {
      var _this3 = this;
      (0, _courseDeclare.getInfoByIdThird)({
        id: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        _this3.form0 = data.form0;
        if (data.form1.courseLeaderTeachingList.length == 0) {
          data.form1.courseLeaderTeachingList.push({
            classHour: "",
            courseName: "",
            courseType: "",
            sessionNumber: "",
            studentNumber: null
          });
        }
        if (data.form2.teamListParams.length == 0) {
          data.form2.teamListParams.push({
            birthday: "",
            jobContent: "",
            major: "",
            name: "",
            remarks: "",
            sex: "",
            technicalPosition: ""
          });
        }
        if (data.form3.courseEachLectureListParams.length == 0) {
          data.form3.courseEachLectureListParams.push({
            duration: "",
            lecturer: "",
            title: ""
          });
        }
        _this3.form1 = data.form1;
        _this3.form2 = data.form2;
        _this3.form3 = data.form3;
        _this3.form4 = data.form4;
        _this3.form5 = data.form5;
        _this3.form6 = data.form6;
        _this3.form7 = data.form7;
        _this3.id = data.form0.courseLeaderId;
        if (data.form0.majorCatId) {
          _this3.isGetMajor = 1;
        }
      });
    },
    // 概要信息 提交
    submit: function submit(v) {
      var _this4 = this;
      this.form0.courseLeaderId = this.id;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _courseDeclare.insertOutline)(_this4.form0).then(function (res) {
            if (res.code === 2000) {
              _this4.$message.success(res.msg);
            }
          });
        }
      });
    },
    // 课程负责人情况 提交
    submit1: function submit1(v) {
      var _this5 = this;
      if (this.id) {
        this.form1.courseLeaderId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourseLeader)(_this5.form1).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this5.$message.success(res.msg);
              }
            });
          }
        });
      } else {
        this.$alert("请先提交“概要信息”");
      }
    },
    // 课程团队 提交insertCourseOverview
    submit2: function submit2(v) {
      var _this6 = this;
      if (this.id) {
        this.form2.courseLeaderId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourseTeam)(_this6.form2).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this6.$message.success(res.msg);
              }
            });
          }
        });
      } else {
        this.$alert("请先提交“概要信息”");
      }
    },
    // 课程情况 提交
    submit3: function submit3(v) {
      var _this7 = this;
      if (this.id) {
        this.form3.courseLeaderId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourseOverview)(_this7.form3).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this7.$message.success(res.msg);
              }
            });
          }
        });
      } else {
        this.$alert("请先提交“概要信息”");
      }
    },
    // 课程评价 提交insertConstructionMeasures
    submit4: function submit4(v) {
      var _this8 = this;
      if (this.id) {
        this.form4.courseLeaderId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertSelfEvaluation)(_this8.form4).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this8.$message.success(res.msg);
              }
            });
          }
        });
      } else {
        this.$alert("请先提交“概要信息”");
      }
    },
    // 建设措施 提交insertFile1
    submit5: function submit5(v) {
      var _this9 = this;
      if (this.id) {
        this.form5.courseLeaderId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertConstructionMeasures)(_this9.form5).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this9.$message.success(res.msg);
              }
            });
          }
        });
      } else {
        this.$alert("请先提交“概要信息”");
      }
    },
    // 建设措施 提交
    submit6: function submit6(v) {
      var _this0 = this;
      if (this.id) {
        this.form6.courseLeaderId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertFile1)(_this0.form6).then(function (res) {
              if (res.code === 2000) {
                _this0.$message.success(res.msg);
              }
            });
          }
        });
      } else {
        this.$alert("请先提交“概要信息”");
      }
    },
    reset: function reset() {
      this.form1 = {
        unit: "",
        courseName: "",
        courseType: "",
        category: "",
        major: "",
        person: "",
        time: ""
      };
    },
    // 课程负责人情况 添加近五年讲授的主要课程
    addWorks: function addWorks() {
      if (this.form1.courseLeaderTeachingList.length < 5) {
        this.form1.courseLeaderTeachingList.push({
          classHour: "",
          courseName: "",
          courseType: "",
          sessionNumber: "",
          studentNumber: null
        });
      } else {
        this.$message.error("近五年来讲授的主要课程最多填写五门");
      }
    },
    // 课程负责人情况 删除近五年讲授的主要课程
    removeWorks: function removeWorks(index) {
      this.form1.courseLeaderTeachingList.splice(index, 1);
    },
    // 课程团队 添加其他人员
    addTeam: function addTeam() {
      this.form2.teamListParams.push({
        birthday: "",
        jobContent: "",
        major: "",
        name: "",
        remarks: "",
        sex: "",
        technicalPosition: ""
      });
    },
    // 课程团队 删除其他人员
    removeTeam: function removeTeam(index) {
      this.form2.teamListParams.splice(index, 1);
    },
    // 每讲情况 添加其他人员
    addCourseItem: function addCourseItem() {
      this.form3.courseEachLectureListParams.push({
        duration: "",
        lecturer: "",
        title: ""
      });
    },
    // 每讲情况 删除其他人员
    removeCourseItem: function removeCourseItem(index) {
      this.form3.courseEachLectureListParams.splice(index, 1);
    },
    getUploadVideo: function getUploadVideo(data) {
      if (data.code === 1) {
        this.form6.lectureVideo = data;
        this.$message.success("上传成功。");
      }
    },
    getUploadOtherFile: function getUploadOtherFile(data) {
      // console.log('123123',data);
      if (data.code === 1) {
        if (this.form6.otherFile1.fileName == "" || this.form6.otherFile1.fileName == null) {
          this.form6.otherFile1 = data;
          this.$message.success("上传成功。");
        } else if (this.form6.otherFile2.fileName == "" || this.form6.otherFile2.fileName == null) {
          this.form6.otherFile2 = data;
          this.$message.success("上传成功。");
        } else {
          this.$message.error("其他材料最多2份");
        }
      }
    },
    delFile1: function delFile1() {
      this.form6.otherFile1 = {
        fileName: "",
        md5: "",
        ossGenUrl: "",
        ossOriUrl: "",
        size: "",
        url: ""
      };
    },
    delFile2: function delFile2() {
      this.form6.otherFile2 = {
        fileName: "",
        md5: "",
        ossGenUrl: "",
        ossOriUrl: "",
        size: "",
        url: ""
      };
    } // 返回
    // isBack() {CourseItem
    //   this.$router.push("/object/object");
    // },
  },
  watch: {
    isGetMajor: {
      handler: function handler(e, o) {
        var _this1 = this;
        (0, _courseDeclare.getMatchMajorListAll)({
          businessId: "",
          parentId: this.form0.majorCatId
        }).then(function (res) {
          if (res.code === 2000) {
            _this1.majorListTwo = res.data;
          }
        });
      },
      deep: true
    }
  },
  created: function created() {
    console.log('this.$route.query.id', this.$route.query.id);
    this.getDetailThird();
    this.getMajor();
    // this.validatePhoneTwo
  },
  mounted: function mounted() {}
};